module.exports = __webpack_public_path__ + "media/images/requisitions/wxzf-a4eb515f930d3dc75442dbe6cb9fa51f.png";